export async function loginUser(credentials: {password: string, login: string}) {
    return fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
      .then(data => data.json())
}

